/**
 * GA4 event layer.
 *
 * Events are pushed to window.dataLayer if a tag is present. No analytics
 * script is bundled by default and no form field values are ever tracked —
 * only the event name and non-sensitive metadata (category, step number).
 */
export type AnalyticsEvent =
  | "view_product"
  | "select_product"
  | "filter_products"
  | "start_gift_finder"
  | "complete_gift_finder"
  | "request_similar_click"
  | "begin_custom_request"
  | "custom_request_step_complete"
  | "upload_inspiration"
  | "submit_custom_request"
  | "custom_request_success"
  | "custom_request_error"
  | "click_phone"
  | "click_email"
  | "faq_expand"
  | "submit_contact_form"
  | "social_click";

type Params = Record<string, string | number | boolean | undefined>;

export function track(event: AnalyticsEvent, params: Params = {}) {
  if (typeof window === "undefined") return;
  const w = window as unknown as { dataLayer?: unknown[] };
  w.dataLayer = w.dataLayer || [];
  w.dataLayer.push({ event, ...params });
}
